import { Center, Loader, LoaderProps } from "@mantine/core"
import { PropsWithChildren, Suspense } from "react"
import { ErrorBoundary } from "./error-context/error-boundary"

interface Props extends PropsWithChildren {
  loadingProps?: LoaderProps
  fallback?: React.ReactNode
}

export function SuspenseWithFallback({
  children,
  loadingProps,
  fallback,
}: Props) {
  return (
    <Suspense
      fallback={
        fallback ?? (
          <Center
            style={{
              height: "100%",
              width: "100%",
            }}
          >
            <Loader size={30} {...loadingProps} />
          </Center>
        )
      }
    >
      {children}
    </Suspense>
  )
}

export function SuspenseWithErrorBoundary({
  children,
  loadingProps,
  fallback,
}: Props) {
  return (
    <SuspenseWithFallback loadingProps={loadingProps} fallback={fallback}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </SuspenseWithFallback>
  )
}
